// Formatting helpers driven by the company profile (locale + currency), never
// by hardcoded assumptions. The shell calls configureFormat() once at boot.

let locale = 'es-ES'
let currency = 'EUR'

export function configureFormat(options = {}) {
  if (options.locale) locale = options.locale
  if (options.currency) currency = options.currency
}

// Un importe lleva SIEMPRE el punto de miles. En castellano Intl no agrupa los
// de cuatro cifras (la norma de la RAE), y en una columna de dinero eso deja
// «7372,80 €» debajo de «52.684,80 €»: parece otra cifra, y en un presupuesto
// nadie lo escribe así. Los demás números no se tocan: un año no es «2.026».
export const formatMoney = (amount) =>
  new Intl.NumberFormat(locale, { style: 'currency', currency, useGrouping: 'always' }).format(Number(amount ?? 0))

// `decimals` is either a fixed count (2 → «1,50») or Intl options for «up to»
// figures ({ maximumFractionDigits: 4 } → «1,5»). An object used to land in
// `minimumFractionDigits` and Intl threw a RangeError that blanked the screen.
export const formatNumber = (value, decimals = 0) => {
  const options = typeof decimals === 'object' && decimals !== null
    ? decimals
    : { minimumFractionDigits: decimals, maximumFractionDigits: decimals }
  return new Intl.NumberFormat(locale, options).format(Number(value ?? 0))
}

export const formatDate = (value) =>
  value ? new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(value)) : '—'

export const formatDateTime = (value) =>
  value ? new Intl.DateTimeFormat(locale, {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }).format(new Date(value)) : '—'

/** "3 minutes ago" style, for feeds. */
export function formatRelative(value) {
  if (!value) return '—'
  const seconds = Math.round((new Date(value) - Date.now()) / 1000)
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })

  const units = [
    ['year', 31536000], ['month', 2592000], ['week', 604800],
    ['day', 86400], ['hour', 3600], ['minute', 60],
  ]
  for (const [unit, size] of units) {
    if (Math.abs(seconds) >= size) return rtf.format(Math.round(seconds / size), unit)
  }
  return rtf.format(seconds, 'second')
}

/** Initials for an avatar placeholder. */
export const initials = (name) =>
  String(name ?? '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase() ?? '')
    .join('')
